import { getAudioGraphInstance } from "../audioEngine";

export const sendNoteOnToWamNode = (wamNode, note, velocity, time) => {
    wamNode.scheduleEvents({ 
        type: 'wam-midi', 
        time: time, 
        data: { 
            bytes: new Uint8Array([0x90, note, velocity]) 
        } 
    });
}

export const sendNoteOffToWamNode = (wamNode, note, velocity, time) => {
    wamNode.scheduleEvents({ 
        type: 'wam-midi', 
        time: time, 
        data: { 
            bytes: new Uint8Array([0x80, note, velocity]) 
        } 
    });
}

export const stopAllNotesForWamNode = (wamNode, time) => {
    wamNode.clearEvents();
    // Stop all notes that are still playing
    for (let pitch = 0; pitch < 128; pitch++) {
        sendNoteOffToWamNode(wamNode, pitch, 0, time);
    }
}

export const createWamNode = async (wamUrl, nomGrup) => {
    const wamInstance = await getAudioGraphInstance().initWamInstance(wamUrl, nomGrup);
    console.debug("WAM node created from:", wamUrl);
    
    // WAM nodes (in wamInstance.audioNode) have a "destroy" method, but other Tone.js nodes that we use
    // in our app have a "dispose" method. To unify the API, we can add a "dispose" method to the WAM node that 
    // calls its "destroy" method.
    wamInstance.audioNode.dispose = () => {
        wamInstance.audioNode.destroy();
    };

    return wamInstance.audioNode;
}